"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _schema = require("../schema");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Authorization = function Authorization(_ref) {
  var children = _ref.children,
      apiLogin = _ref.apiLogin,
      callback = _ref.callback;

  var handleSend = function handleSend(params, _ref2) {
    var setErrors = _ref2.setErrors,
        setSubmitting = _ref2.setSubmitting;
    apiLogin(params).then(function (res) {
      callback(res);
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data);
      }

      setSubmitting(false);
    });
  };

  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    validationSchema: _schema.AuthSchema,
    onSubmit: handleSend,
    initialValues: {
      username: '',
      password: ''
    }
  }, function (data) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children(data));
  });
};

Authorization.propTypes = {
  children: _propTypes.default.func.isRequired,
  callback: _propTypes.default.func.isRequired,
  apiLogin: _propTypes.default.any.isRequired
};
var _default = Authorization;
exports.default = _default;